import type { OlProps } from "@components/OlProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getReasonsAudit(tenant: Tenant): OlProps[] {
	return [
		{
			title: "Ke každému auditu přistupujeme individuálně",
			desc: "Na audit nepoužíváme jednotnou šablonu. Každý obor a firma je individuální, a tak doporučení a úpravy děláme na základě reálných potřeb klienta.",
		},
		{
			title: "Weby jsou pro nás každodenní chleba",
			desc: "Weby nejen auditujeme a optimalizujeme, ale také vyvíjíme. Pracujeme s nimi den co den už dlouhá léta.",
		},
		{
			title: "Nemusíme skončit auditem",
			desc: "Když budete chtít, po dokončení audit vám navrhneme cenově dostupné řešení, které vám pomůže s webem dosáhnout obchodně-marketingových cílů.",
		},
		{
			title: "Co si dohodneme, to platí",
			desc: "Žádné nafouknuté fakturace a sliby, které nemůžeme splnit. Co si společně domluvíme, to platí.",
		},
	];
}
